import React, { useState } from "react";

const InquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Immediately show the success message
    alert("Inquiry submitted successfully!");

    // Submit the form data to the backend asynchronously
    (async () => {
      try {
        const response = await fetch("https://growhomestudio.onrender.com/api/inquiries", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          console.log("Data successfully sent to the backend.");
        } else {
          console.error("Backend submission failed.");
        }
      } catch (error) {
        console.error("Error during backend submission:", error);
      }
    })();

    // Clear the form fields after submission
    setFormData({
      name: "",
      mobile: "",
    });
  };

  return (
    <div className="inquiry-form py-5 px-5 max-w-lg mx-auto w-full">
      <h4 className="text-xl font-bold text-left mb-6">
        Affordable,<br /> personalized designs in minutes
      </h4>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Name and Mobile Field Layout */}
        <div className="grid grid-cols-1 gap-4">
          {/* Name Field */}
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700"
            />
            <input
              placeholder="Name"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full h-12 px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Mobile Field */}
          <div className="relative">
            <input
              placeholder="Phone Number"
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full h-12 pl-12 pr-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Flag_of_India.svg/800px-Flag_of_India.svg.png"
              alt="Indian Flag"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-4 object-contain bg-opacity-20%"
            />
          </div>
        </div>

        {/* WhatsApp Update Checkbox */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="whatsapp-updates"
            className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            defaultChecked
          />
          <label htmlFor="whatsapp-updates" className="text-sm text-gray-700">
            Receive WhatsApp updates
          </label>
        </div>

        {/* Submit Button */}
        <div className="pt-2">
          <button
            type="submit"
            className="w-full py-3 bg-[#e9a200] text-white rounded-2xl focus:outline-none focus:ring-2 focus:ring-yellow-500"
          >
            Submit Inquiry
          </button>
        </div>

        {/* Privacy Policy and Terms Links */}
        <div className="text-sm text-gray-600 mt-4 pt-4">
          By submitting this form, you agree to <br />
          <a href="/privacy-policy" className="text-blue-500 hover:underline">
            privacy policy
          </a>{" "}
          &{" "}
          <a
            href="/terms-and-conditions"
            className="text-blue-500 hover:underline"
          >
            terms and conditions
          </a>
        </div>
      </form>
    </div>
  );
};

export default InquiryForm;
